import React from "react"
import { Box } from "./box"
import styled from "styled-components"

const IconTextBox = styled(Box)`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`

export const IconTextButtonBox = styled(Box)`
  font-size: 1.6rem;
  font-weight: 600;
  border-width: 0;
  padding: 0;
  color: ${props => props.theme.colors[props.color] || props.theme.colors.text};
  border-radius: ${props => props.borderRadius};
  cursor: ${props => (props.disabled ? "default" : "pointer")};
  opacity: ${props => props.disabled && "0.2"};
`

export const IconTextButton = ({ onClick, icon, color, text, ...props }) => {
  return (
    <IconTextButtonBox onClick={onClick} color={color} {...props}>
      <IconTextBox>
        {icon} 
        {text}
      </IconTextBox>
    </IconTextButtonBox>
  )
}